import { MetadataKey } from "@syla/shared/types/models/TransactionBase";
import { OrderResponseItem } from "@syla/shared/types/responses/OrderResponseItem";
import { startCase } from "lodash";
import { useMemo } from "react";

export function useGetTxHint(orderResponse: OrderResponseItem) {
  return useMemo(() => {
    for (const transaction of orderResponse.transactions) {
      const smartContractCall = transaction.metadata?.find(
        (meta) => meta.name === MetadataKey.ContractMethod,
      )?.value;

      if (smartContractCall && !/^0x/i.test(smartContractCall)) {
        return startCase(smartContractCall);
      }

      if (transaction.description) {
        return transaction.description.split(" - ")[0]?.trim();
      }
    }

    return undefined;
  }, [orderResponse.transactions]);
}
